import { Fragment } from 'react';
import { Form, Tag } from 'antd';
import { TAG_COLORS } from '@gtintel/platform-constants';
import styles from './tagSection.module.scss';
const TagSection = props => {
  const {
    tags,
    project
  } = props;
  const projectTagIds = project?.tags?.map(({
    id
  }) => id) || [];

  // Show the first two tags in the project
  const displayedTags = tags?.filter(tag => projectTagIds.some(id => id === tag.id)).slice(0, 2);
  return <div className={styles.container}>
      {displayedTags.map((tag, index) => <Fragment key={index}>
          <Form.Item className={styles.tagLayout}>
            <Tag color={TAG_COLORS[Number(tag.tag_group_code ?? tag.tag_group)]}>
              {tag.name}
            </Tag>
          </Form.Item>
        </Fragment>)}
    </div>;
};
export default TagSection;